

export interface OptionRendererProps {
    option: { id: string | number | null, label: string, value: string | number, data?: Record<string, any> },
    onChange: (id: string | number | null) => void
    selectedOptionId: string | null | number;
    name: string | undefined,
}
export function OptionRenderer({
    option,
    onChange,
    selectedOptionId,
    name
}: OptionRendererProps) {
    return <div className="form-check">
        <input
            className="cursor-pointer form-check-input"
            onChange={(event) => onChange(option.id)}
            checked={selectedOptionId === option.id}
            type="radio"
            id={name}
            name={name}
        />
        <label className="form-check-label fs-5">{option.label}</label>
    </div>
}


export interface RadioGroupProps {
    name: string | undefined;
    options: { id: string | number | null, label: string, value: string | number, data?: Record<string, any> }[]
    selectedOptionId: string | null | number;
    onChange: (id: string | number | null) => void
    optionRenderer?: (props: OptionRendererProps) => JSX.Element
}


export function RadioGroup({
    name = '',
    options = [],
    selectedOptionId,
    onChange,
    optionRenderer = OptionRenderer
}: RadioGroupProps) {
    return <div className="d-flex flex-column justify-content-center gap-4">

        {options?.map((option, index) =>
            <div key={`radio-group-name-option-${index}`} className="d-flex align-items-center justify-content-between gap-4">
                {optionRenderer({
                    option,
                    onChange,
                    selectedOptionId,
                    name
                })}
            </div>
        )}

    </div>
}